import React, { useContext, useState } from "react";
import "./loanlistaction.scss";
import {
  IconButton,
  Typography,
  Stack,
  Box,
  Grid,
  Button,
  Divider,
  TextField,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import ClearIcon from "@mui/icons-material/Clear";
import { useMutation } from "@apollo/client";
//components
import { AuthContext } from "../../../context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";
import { UPDATE_COMMENT_BY_LOAN } from "../../../Schema/Loanlist";

export default function UpdateComment({
  open,
  handleClose,
  editData,
  setRefetch,
}) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState({ comment: "" });
  const { setAlert } = useContext(AuthContext);

  const [updateCommentByLoan] = useMutation(UPDATE_COMMENT_BY_LOAN, {
    onCompleted: ({ updateCommentByLoan }) => {
      // console.log("updateCommentByLoan::", updateCommentByLoan);
      if (updateCommentByLoan?.isSuccess) {
        setAlert(true, "success", updateCommentByLoan?.message);
        setRefetch();
        handleClose()
        setLoading(false);
      } else {
        setAlert(true, "error", updateCommentByLoan?.message);
      }
    },
    onError: (error) => {
      console.log(error);
      setAlert(true, "error", error?.message);
      setLoading(false);
    },
  });

  // console.log("editData::", editData);

  const handleFirstApprove = () => {
    setLoading(true);
    let comments = [];
    comments.push(comment)
    updateCommentByLoan({
      variables: {
        idLoan: editData?._id,
        comment: comments,
      },
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} className="loanlist-action">
      <DialogTitle>
        <Stack direction="row">
          <Typography
            className={language === "kh" ? "dialog-titleKh" : "dialog-titleEn"}
          >
            {t("comment")}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <ClearIcon className="close-icon" />
          </IconButton>
        </Stack>
        <Divider />
      </DialogTitle>

      <DialogContent>
        <Typography
          variant="subtitle1"
          className={language === "kh" ? "simple-textKh" : "simple-textEn"}
        >
          {t("comment")}
        </Typography>
        <TextField
          fullWidth
          multiline
          size="small"
          placeholder="comment"
          onChange={(e) => setComment({ comment: e.target.value })}
        />
      </DialogContent>

      <DialogActions>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box className="action">
              <Button
                className="btn"
                variant="outlined"
                fullWidth
                disabled={comment === "" ? true : false}
                onClick={handleFirstApprove}
                sx={{
                  backgroundColor:
                    comment === "" ? "gray" : "#38b14a !important",
                }}
              >
                {loading ? (
                  "Loading..."
                ) : (
                  <Typography
                    className={language === "kh" ? "suspendKh" : "suspendEn"}
                  >
                    {t("comment")}
                  </Typography>
                )}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
